import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'

import config from 'config'

import LoadingPage from 'layouts/LoadingPage'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
  }, dispatch)
})

export default compose(
  connect(null, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      // If you still have this in your localstorage, you haven't created an account yet & can't just log in
      if (window.localStorage.getItem('hyfy_redirect_uri')) {
        window.localStorage.removeItem('drift_video_webstore_referrer')
        window.localStorage.setItem('hyfy_account_referrer', 'extension-sign-in')
        this.props.actions.push('/start/video')
      } else {
        window.location.replace(`${config.DRIFT_VIDEO_HOMEPAGE}/accounts/login`)
      }
    },
  }),
)(LoadingPage)



// WEBPACK FOOTER //
// ./src/layouts/VideoExtensionLoginRedirect/index.js